/**
 * @enum {enumBeaconType} The different possible types of beacons
 */
export enum enumBeaconType {
  Error = 'error', // an error
  Info = 'info', // information
  Success = 'success', // success 
  Warning = 'warning', // a warning
}
